import React from 'react';
import {get} from 'lodash';
import className from 'classnames';

import ImageLoader from './ImageLoader'
import DotTooltip from './DotTooltip'

class UserWithImage extends React.Component {
  static propTypes = {
  };

  static defaultProps = {
    hideImage: false,
    hideNickname: false,
  };

  state = {
  };

  render = () => {
    return (
      <div
        className={className('UserWithImage', {
          'UserWithImage--hide-nickname': this.props.hideNickname || this.props.hideImage,
        })}
      >
        {!this.props.hideImage &&
          <div className='ImageBorder'>
            <ImageLoader
              klassName='UserWithImage__image'
              url={get(this.props, 'user.profileIcon.thumb.url')}
            />
          </div>
        }

        <DotTooltip
          user={this.props.user}
        />

        {!this.props.hideNickname &&
          <span className='UserWithImage__span'>
            {get(this.props, 'user.nickname')}
          </span>
        }
      </div>
    );
  }
}

export default UserWithImage;
